/**
 * Defines the types of credit cards documents to help separate
 * different wizard document and prevent corruption
 */
export default {
    CARD_FINDER: 'cc-cardfinder',
    HOSTED_APP: 'cc-app',
};
